import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from './App';
import { AuthProvider } from './features/auth/AuthContext';
import './lib/installPrompt'; // chytá beforeinstallprompt hned při startu
import './styles/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found in index.html');

/**
 * Dotyková zařízení: přidáme třídu `.touch` na <html>. CSS na ni navazuje
 * trvalé zobrazení akčních tlačítek (✕ pro odebrání řádku/chipu, pickery),
 * která jsou jinak skrytá za :hover. Media query `(hover: none)` na některých
 * PWA/tabletech selhává, proto detekujeme dotyk přímo z JS (spolehlivější).
 */
if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
  document.documentElement.classList.add('touch');
}

/**
 * Basename odvozujeme z Vite `base` — když se app deployuje pod /v2/,
 * musí to vědět i React Router, jinak všechny interní Link-y míří na /.
 * V dev módu (vite dev) zůstane na '/'.
 */
const ROUTER_BASENAME = import.meta.env.BASE_URL.replace(/\/$/, '') || undefined;

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={ROUTER_BASENAME}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
